import Vue from "vue";
import Gekko from "./Gekko.vue";
import router from "../../router";
import store from "../../store";
import GetTextPlugin from "vue-gettext";
import translations from "../../../../app/static/js/vue_translations.json";
import * as VueGoogleMaps from 'vue2-google-maps';
import PortalVue from 'portal-vue';

Vue.use(require('vue-cookies'));
// import css variables globally
import '@/css/style.scss'
// BOOTSTRAP
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue/dist/bootstrap-vue.esm';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

// FILTERS
import '../../filters/filters';

// DIRECTIVES
import '../../directives/confirm.directive';
import '@/directives/gk-confirm.directive';

// https://github.com/LinusBorg/portal-vue
Vue.use(PortalVue)

// OVERLAY SCROLLBARS 
// https://github.com/KingSora/OverlayScrollbars/tree/master/packages/overlayscrollbars-vue
import 'overlayscrollbars/css/OverlayScrollbars.css';
import { OverlayScrollbarsPlugin } from 'overlayscrollbars-vue';
Vue.use(OverlayScrollbarsPlugin);

// FONT AWESOME ICONS v6.2
      /* import the fontawesome core */
      import { library } from '@fortawesome/fontawesome-svg-core'

      /* import font awesome icon component */
      import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

      /* import specific icons */
      import { fas } from '@fortawesome/free-solid-svg-icons'
      import { far } from '@fortawesome/free-regular-svg-icons'

      /* add icons to the library */
      library.add(fas) // to include all solid icons
      library.add(far) // to include all regular icons

      /* add font awesome icon component */
      Vue.component('font-awesome-icon', FontAwesomeIcon)

// GLOBAL COMPONENTS
import ConfirmModal from "@/components/ui/ConfirmModal";
Vue.component('confirm-modal', ConfirmModal)

// SENTRY   as seen here: https://docs.sentry.io/platforms/javascript/guides/vue/
import * as Sentry from "@sentry/vue";
import { Vue as VueIntegration } from '@sentry/integrations';
const serverErrorsRegex = new RegExp(
      "500 Internal Server Error|401 Unauthorized|403 Forbidden|404 Not Found|502 Bad Gateway|ResizeObserver|Non-Error promise",
      "mi"
    );
if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1"){
  Sentry.init({
    Vue: Vue,
    attachStacktrace: true,
    initialScope: {
        user: { id: window.user_id },
    },
    dsn: "https://77be99f7c67146379ed0b14492ea601a@o18359.ingest.sentry.io/35701",
    integrations: [ new VueIntegration({ Vue, attachProps: true,consoleOutput: true}) ],
    // ignoreErrors: ['ResizeObserver loop limit exceeded'],
    ignoreErrors: [serverErrorsRegex]
  });
}

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAd_PSsTfkw_5sBihe1kKSHCJJQ5l7cJb8',
    libraries: 'places',
  }
});

Vue.prototype.$checkPremium = function (is_premium, handler, ...args) {
  if (is_premium) {
    return handler.apply(this, args)
  } else {
    store.commit('togglePremiumModal');
  }
}

// Translation Config
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en: "English",
    es: "Español",
    nl: "Dutch"
  },
  defaultLanguage: "en",
  translations: translations
});
Vue.config.productionTip = false;

export const interpolate = Vue.prototype.$gettextInterpolate;
export default Vue.prototype.$gettext;

// put Urls variable in each component
Vue.prototype.Urls = window.Urls;

new Vue({
  router,
  store,
  render: h => h(Gekko)
}).$mount("#app");
